import pl from './pl';

/** All Polish UI strings for the contact-request epic. Import this instead of writing inline text. */
export const CONTACT_REQUEST_LABELS = pl;

/**
 * UI strings for the admin "My Contact Requests" tab (RR-1095) on `/Zgłoszenia`.
 *
 * Language follows the design: the tab label and empty-state copy are English
 * (kept verbatim from the mockup), while the column headers stay Polish to
 * match the sibling "Zgłoszenia kontaktowe" list, and the no-search-results
 * copy stays Polish to match the rest of the app.
 */
export const MY_CONTACT_REQUESTS_LABELS = {
  // Tab (English, per design)
  TAB_LABEL: 'My Contact Requests',

  // Search — rotating placeholders cycle through the searchable fields so users
  // can discover what they can search by (Request ID, Client Name).
  SEARCH_PLACEHOLDER: 'Szukaj po ID zgłoszenia lub nazwie klienta',
  SEARCH_PLACEHOLDERS: ['Szukaj po ID zgłoszenia', 'Szukaj po nazwie klienta'],

  // Toolbar
  COLUMNS_ARIA: 'Kolumny',
  COLUMNS_REQUIRED_TOOLTIP: 'Ta kolumna jest wymagana',

  // Column headers (Polish, matching the contact-request list)
  COLUMN_REQUEST_ID: 'ID zgłoszenia',
  COLUMN_CLIENT_NAME: 'Nazwa klienta',
  COLUMN_CLIENT_ID: 'ID klienta',
  COLUMN_EMAIL: 'Adres e-mail',
  COLUMN_PHONE: 'Numer telefonu',
  COLUMN_SUBJECT: 'Temat',
  COLUMN_CREATED_AT: 'Data utworzenia',
  COLUMN_STATUS: 'Status',
  COLUMN_ACTIONS: 'Akcje',
  PLACEHOLDER_NA: '—',

  // Row action menu
  ACTION_VIEW: 'Podgląd',

  // Empty state — no records assigned (English, per design)
  EMPTY_TITLE: 'No contact requests assigned yet.',
  EMPTY_DESCRIPTION:
    'Once contact requests are assigned to you, they will be listed here.',

  // No search / filter results (Polish, matching the rest of the app)
  NO_RESULTS_TITLE: 'Brak wyników.',
  NO_RESULTS_DESCRIPTION_SEARCH: 'Spróbuj zmienić kryteria wyszukiwania.',
  NO_RESULTS_DESCRIPTION_FILTER: 'Spróbuj zmienić ustawienia filtrów.',
  NO_RESULTS_DESCRIPTION_BOTH:
    'Spróbuj zmienić kryteria wyszukiwania lub filtry.',
} as const;
